// VERIFY ALPHA CARACTERES
export const verifyAlpha = value => {
  if (!/^[a-zA-Z0-9.]*$/g.test(value)) {
    return true;
  }
  return false;
};

// VERIFY NUMBERS
export const verifyNumbers = value => {
  if (!/^[0-9]+$/g.test(value)) {
    return true;
  }
  return false;
};

// FORMAT MONEY
export const formatMoney = value => {
  if (typeof value === "string") {
    return parseFloat(
      value
        .toString()
        .replace("R$ ", "")
        .replace("R$", "")
        .replace(" ", "")
        .replace(/\./g, "")
        .replace(",", ".")
    );
  }
  if (value === undefined) {
    return 0;
  }
  return value;
};

// FORMAT PERCENT
export const formatPercent = value => {
  if (typeof value === "string") {
    return parseFloat(value.toString().replace(",", "."));
  }
  if (value === undefined) {
    return 0;
  }
  return value;
};

// VERIFY E-MAIL CARACTERES
export const verifyEmail = value => {
  if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)) {
    return true;
  }
  return false;
};

// FORMATA REAL
export const formatReal = value => {
  if (value !== null && value !== undefined) {
    return value
      .toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL"
      })
      .replace("R$", "");
  } else {
    return 0;
  }
};

// FORMAT FILE SIZE

export const formatSize = value => {
  if (value > 1024 * 1024 * 1024 * 1024) {
    return (value / 1024 / 1024 / 1024 / 1024).toFixed(2) + " TB";
  } else if (value > 1024 * 1024 * 1024) {
    return (value / 1024 / 1024 / 1024).toFixed(2) + " GB";
  } else if (value > 1024 * 1024) {
    return (value / 1024 / 1024).toFixed(2) + " MB";
  } else if (value > 1024) {
    return (value / 1024).toFixed(2) + " KB";
  }
  return value.toString() + " B";
};

export const orderByName = (a, b) => {
  if (a.name > b.name) {
    return 1;
  }
  if (a.name < b.name) {
    return -1;
  }
  // a must be equal to b
  return 0;
};



// WEBPACK FOOTER //
// ./src/helpers/index.js